<template>
  <div>
    <el-dialog
      title="选择打印培训档案"
      :visible.sync="visible" style="padding: 30px">
      <div class="checkbox">
        <el-checkbox-group v-model="checkList">
          <el-col :span="12">
            <el-checkbox :label="exportFileConstant.asyncFileExportType.trainingRecordByTask">学习记录</el-checkbox>
          </el-col>
          <el-col :span="12">
            <el-checkbox :label="exportFileConstant.asyncFileExportType.proofOfHoursByTask">学时证明</el-checkbox>
          </el-col>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {bus} from "../../../bus";
import $exportFileConstant from '@/pages/trainingManagement/component/exportFile/exportFileConstant'

export default {
  name: "taskFile",
  data(){
    return {
      visible: false,
      taskId: undefined,
      checkList: [],
      exportFileConstant: $exportFileConstant,
      submitLoading: false
    }
  },
  methods: {
    showSelect(taskId){
      this.taskId = taskId;
      this.visible = true;
    },
    clear() {
      this.visible = false;
      this.checkList = [];
      this.submitLoading = false;
    },
    submit() {
      if (!this.checkList || this.checkList.length < 1) {
        this.$message.error('请至少选择一项打印');
        return;
      }
      let parmas = this.checkList.map(type => {
        return {
          type:  parseInt(type),
          fileName: '学时证明文件',
          param: {
            programTasksId:  this.taskId
          }
        }
      })
      this.submitLoading  = true;
      bus.$emit('putAsyncTasks', parmas)
    }
  },
  created() {
    bus.$on('putAsyncTasksSucess', _ => {
      this.clear();
    });
    bus.$on('putAsyncTasksError', msg => {
      this.submitLoading = false;
    });
  }
}
</script>

<style scoped>

  .checkbox {
    background-color: #f0f5fb;
    padding: 20px;
    margin: 20px;
    margin-bottom: 30px;
    overflow: hidden;

  }

</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/task/taskFile.vue